export default __webpack_public_path__ + "static/media/logo-back.ef01d2bc.PNG";